import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import ULPackage2Builder from '../components/sections/ULPackage2.builder';

Builder.registerComponent(ULPackage2Builder, {
    name: BUILDER_DIVIDER_NAMES.UnlimitedPackage2,
});
